module.exports = __webpack_public_path__ + "static/img/logo.6410551.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.svg
// module id = ICZV
// module chunks = 41